import { BASE_URL } from './config';

export const login = async (email, password, isAdminLogin = false) => {
  try {
    const body = {
      email,
      password,
    };

    if (isAdminLogin) {
      body.isAdminLogin = true;
    }

    const res = await fetch(`${BASE_URL}auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    let data = {};
    try {
      data = await res.json();
    } catch (e) {
      data = {};
    }

    if (res.ok) {
      return { success: true, data };
    } else {
      return {
        success: false,
        error:
          data.message || data.error || `HTTP error! status: ${res.status}`,
        data,
        httpStatus: res.status,
      };
    }
  } catch (error) {
    console.error('Login API Error:', error);
    return { success: false, error: error.message };
  }
};

export const loginGoogle = async tokenId => {
  const res = await fetch(`${BASE_URL}auth/google`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id_token: tokenId }),
  });
  return res.json();
};

export const register = async userData => {
  const res = await fetch(`${BASE_URL}auth/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  });
  return res.json();
};

export const verifyOtp = async (email, code, purpose = 'email_verify') => {
  const res = await fetch(`${BASE_URL}auth/otp/verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, code, purpose }),
  });
  return res.json();
};

export const reqOtp = async (token, email, purpose) => {
  try {
    const res = await fetch(`${BASE_URL}auth/otp/request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ email, purpose }),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Request OTP API Error:', error);
    return { success: false, error: error.message };
  }
};

export const otpChangePass = async email => {
  try {
    const res = await fetch(`${BASE_URL}auth/password/forgot`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Request OTP for Change Password API Error:', error);
    return { success: false, error: error.message };
  }
};

export const otpChangePassVerify = async (email, code) => {
  const res = await fetch(`${BASE_URL}auth/password/reset/verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, code }),
  });
  return res.json();
};

export const resetPassword = async (email, code, new_password) => {
  const res = await fetch(`${BASE_URL}auth/password/reset`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, code, new_password }),
  });
  return res.json();
};

export const verifyOtpSign = async (token, payload) => {
  const res = await fetch(`${BASE_URL}auth/otp/verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const changePassword = async (current_password, new_password, token) => {
  const res = await fetch(`${BASE_URL}profile/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ current_password, new_password }),
  });
  return res.json();
};
